import magicLoginCodes from "../../errorCodes/Magic"

export default function (code: string) {
  switch (code) {
    case magicLoginCodes.MagicUnexpected:
      return "errors.magic.PBMagicUnexpected"
    case magicLoginCodes.MagicExpired:
      return "errors.magic.PBMagicExpired"
    case magicLoginCodes.MagicBadRequest:
      return "errors.magic.PBMagicBadRequest"
    case magicLoginCodes.MagicResendNotAllowed:
      return "errors.magic.PBMagicResendNotAllowed"
    case magicLoginCodes.MagicAlreadyUsed:
      return "errors.magic.PBMagicAlreadyUsed"
    case magicLoginCodes.MagicUndeliverableEmail:
      return "errors.magic.PBMagicUndeliverableEmail"
  }
}
